exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._horizontal-scroll[data-v-5ce095ec]{box-sizing:border-box;overflow-x:scroll;overflow-y:hidden;text-align:left;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-horizontal-scroll/dist/vue-horizontal-scroll.css
// module id = /YWH
// module chunks = 0